export default function RequiresFeaturesDirectives(
	usersService,
	ngShowDirective
) {
	'ngInject';

	var ngShow = ngShowDirective[0];
	return {
		transclude: ngShow.transclude,
		priority: ngShow.priority - 1,
		terminal: ngShow.terminal,
		restrict: ngShow.restrict,
		scope: false,
		link: function(scope, elt, attrs) {
			var features = scope.$eval(attrs.requiresFeatures);

			var validComponent = usersService.hasRequiredFeatures;

			var initialNgIf = attrs.ngShow,
				ifEvaluator;
			// if it exists, evaluates ngShow && ifAuthenticated
			if (initialNgIf) {
				ifEvaluator = function() {
					return scope.$eval(initialNgIf) && validComponent(features);
				};
			} else {
				// if there's no ng-if, process normally
				ifEvaluator = function() {
					return validComponent(features);
				};
			}
			attrs.ngShow = ifEvaluator;
			ngShow.link.apply(ngShow, arguments);
		}
	};
}
